import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
// import {NgxEditorModule} from 'ngx-editor';
import { NgxEditorModule } from 'ngx-editor';

import {ConsentTranslateDialogComponent} from './consent-translate-dialog.component';
import {ReactiveFormsModule} from '@angular/forms';
// import {MatButtonModule, MatDialogModule} from '@angular/material';
import { QuillModule } from 'ngx-quill'
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
    declarations: [ConsentTranslateDialogComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxEditorModule,
        MatButtonModule,
        MatDialogModule,
        QuillModule
    ]
})
export class ConsentTranslateDialogModule {
}
